import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchInfo } from "./store/information";
import Stations from "./components/Stations";
import StackPayesh from "./pages/StackPayesh";
import StationData from "./pages/StationData";
import PayeshPage from "./pages/PayeshPage";
import NotFound from "./pages/NotFound";
import HomePage from "./pages/HomePage";
import NavBar from "./components/NavBar";
import SoundPayesh from "./pages/SoundPayesh";
import LoginPage from "./authentication/LoginPage";
import StationFullDataPaginated from "./pages/StationFullDataPaginated";
import TestStationFullDataPaginated from "./pages/TestStationFullDataPaginated";
import SATA2TestStationFullDataPaginated from "./pages/SATA2TestStationFullDataPaginated";
import SATAStationFullDataPaginated from "./pages/SATAStationFullDataPaginated";
import MultigasHistory from "./pages/MultigasHistory";
import DeviceTest from "./pages/DeviceTest";
import Footer from "./components/Footer";
import SoundStationsFullDataPaginated from "./pages/SoundStationsFullDataPaginated";
import StackStationsFullDataPaginated from "./pages/StackStationsFullDataPaginated";
import Displayer from "./pages/Displayer";
import ChartsPage from "./pages/ChartsPage";
import SoundChartPage from "./pages/SoundChartsPage";
import WeatherPayesh from "./pages/WeatherPayesh";
// import DashboardLogin from "./pages/dashboard/DashboardLogin";
import Testcsrf from "./authentication/Testcsrf";
// import Testcsrf from "./pages/test/Testcsrf";
import Twelve from "./pages/test/Twelve";
import Information from "./pages/Information";
import Comparison from "./pages/Comparison";
import useAuthenticateTokens from "./authentication/useAuthenticateTokens";
import useGetUserInfo from "./authentication/useGetUserInfo";
import { getUserInfo } from "./store/login";
// import Dashboard from "./pages/dashboard/Dashboard";
// import DashboardData from "./pages/dashboard/DashboardData";
// import DashboardDataOffline from "./pages/dashboard/DashboardDataOffline";
// import DashboardDataTest from "./pages/dashboard/DashboardDataTest";
// import DashboardDataOPM from "./pages/dashboard/DashboardDataOPM";
// import DashboardDataAir from "./pages/dashboard/DashboardDataAir";
// import DashboardDataSound from "./pages/dashboard/DashboardDataSound";
// import DashboardDataStack from "./pages/dashboard/DashboardDataStack";
// import DashboardInformation from "./pages/dashboard/DashboardInformation";
// import DashboardLog from "./pages/dashboard/DashboardLog";
// import DashboardUsers from "./pages/dashboard/DashboardUsers";

function AppContent() {
  useAuthenticateTokens();
  getUserInfo();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = () => {
      dispatch(fetchInfo());
    };

    fetchData();

    const intervalId = setInterval(fetchData, 900000); // 900000 ms = 15 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);
  const location = useLocation();

  // Function to check if the current route should show NavBar and Footer
  const shouldShowNavBarAndFooter = () => {
    const excludedRouteRegex = /^\/Urban-TV/i; // Remove the trailing slash
    const excludedPaths = ["/dashboard"]; // Add any paths that should not show NavBar and Footer
    const isExcluded = excludedPaths.some((path) =>
      location.pathname.toLowerCase().startsWith(path)
    );
    return !excludedRouteRegex.test(location.pathname) && !isExcluded;
  };

  return (
    <div className="container-fluid g-0 bg-light text-bg-light overflow-hidden">
      {shouldShowNavBarAndFooter() && <NavBar />}
      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/payesh" element={<PayeshPage />} />
        <Route exact path="/weather" element={<WeatherPayesh />} />
        <Route exact path="/stations" element={<Stations />} />
        <Route path="/stations/:theRouteUrl" element={<StationData />} />
        <Route
          path="/station-Data/:theRouteUrl"
          element={<StationFullDataPaginated />}
        />
        <Route
          path="/test-Data/:theRouteUrl"
          element={<TestStationFullDataPaginated />}
        />
        <Route
          path="/sound-Data/:theRouteUrl"
          element={<SoundStationsFullDataPaginated />}
        />
        <Route
          path="/stack-Data/:theRouteUrl"
          element={<StackStationsFullDataPaginated />}
        />
        {/* <Route path="/aaabbbccc" element={<Testcsrf />} /> */}
        <Route path="/station-charts/:theRouteUrl" element={<ChartsPage />} />
        <Route
          path="/soundStation-charts/:theRouteUrl"
          element={<SoundChartPage />}
        />
        <Route path="/stacks" element={<StackPayesh />} />
        <Route path="/sound" element={<SoundPayesh />} />
        {/* <Route path="/Dashboard" element={<Dashboard />} /> */}
        {/*   <Route path="/Dashboard/Data" element={<DashboardData />} />
        <Route
          path="/Dashboard/Data/Offline"
          element={<DashboardDataOffline />}
        />
        <Route path="/Dashboard/Data/Test" element={<DashboardDataTest />} />
        <Route path="/Dashboard/Data/OPM" element={<DashboardDataOPM />} />
        <Route path="/Dashboard/Data/Air" element={<DashboardDataAir />} />
        <Route path="/Dashboard/Data/Sound" element={<DashboardDataSound />} />
        <Route path="/Dashboard/Data/Stack" element={<DashboardDataStack />} />
        <Route
          path="/Dashboard/information"
          element={<DashboardInformation />}
        />
        <Route path="/Dashboard/Users" element={<DashboardUsers />} />
        <Route path="/Dashboard/Log" element={<DashboardLog />} /> */}
        {/* <Route path="/Dashboard/Login" element={<DashboardLogin />} /> */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/twelve" element={<Twelve />} />
        <Route path="/information" element={<Information />} />
        <Route exact path="/test" element={<DeviceTest />} />
        <Route
          exact
          path="/SATA-test/:theRouteUrl"
          element={<SATA2TestStationFullDataPaginated />}
        />
        <Route
          exact
          path="/SATA-history/:theRouteUrl"
          element={<SATAStationFullDataPaginated />}
        />
        <Route
          exact
          path="/multigas-history/:theRouteUrl"
          element={<MultigasHistory />}
        />
        <Route exact path="/Urban-TV/:theRouteUrl" element={<Displayer />} />
        <Route path="/*" element={<NotFound />} />
        <Route path="/comparison" element={<Comparison />} />
      </Routes>
      {shouldShowNavBarAndFooter() && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
